import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-un-authorise-page',
    templateUrl: './un-authorise-page.component.html',
    styleUrls: ['./un-authorise-page.component.css'],
    standalone: false
})
export class UnAuthorisePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
